import { render, staticRenderFns } from "./DialogPetition.vue?vue&type=template&id=297df99b&"
import script from "./DialogPetition.vue?vue&type=script&lang=js&"
export * from "./DialogPetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports